import { Box, Typography } from "@mui/material";
import RefreshButton from "./RefreshButton";

export default function RefreshErrorView(props) {
    const { onRefresh } = props
    return <Box style={{ display: "flex", flexDirection: "row", justifyItems: "center", alignItems: "center" }} >
        <Typography color={"GrayText"} variant={"subtitle2"}>Something went wrong</Typography>
        <RefreshButton data-test="refresh_button" onRefresh={onRefresh} />
    </Box>
}